import { createContext } from "react";

/**
 * This is to support the other UX simplification hooks/components.
 * You need to use the toggle in `useUXSimplificationFeature` instead.
 *
 * @example
 * ```tsx
 * const { toggleUXSimplification } = useUXSimplificationFeature();
 * ```
 */
type StylesheetsContextValueType = (enabled: boolean) => void;

export default createContext<StylesheetsContextValueType>(() => {
	throw new Error("useSetUXSimplificationStylesheets must be used within a StylesheetsProvider");
});
